// src/components/common/ReportCard/ReportCard.jsx
import React from "react";
import PropTypes from "prop-types";
import { Card, CardContent, CardActions, Typography, Button, Box } from "@mui/material";
import "./ReportCard.css";

const ReportCard = ({ icon: Icon, title, description, buttonLabel, onButtonClick }) => {
    return (
        <Card className="report-card">
            <CardContent>
                <Box className="report-icon">
                    <Icon fontSize="large" />
                </Box>
                <Typography variant="h5" className="report-title">
                    {title}
                </Typography>
                <Typography variant="body2" className="report-description">
                    {description}
                </Typography>
            </CardContent>
            <CardActions>
                <Button 
                    className="report-button primary-button"
                    onClick={onButtonClick}
                >
                    {buttonLabel}
                </Button>
            </CardActions>
        </Card>
    );
};

ReportCard.propTypes = {
    icon: PropTypes.elementType.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    buttonLabel: PropTypes.string.isRequired,
    onButtonClick: PropTypes.func.isRequired,
};

export default ReportCard;
